import React from 'react';

export default function Footer() {
  return (
    <footer>
      <div>Source: NSW Government</div>
    </footer>
  );
}
